import { create } from "zustand";
import { clearToken, getToken, setToken } from "@/api/client";
import type { Role, SessionUser } from "@/api/auth";

export type { Role, SessionUser };

interface AuthState {
  token: string | null;
  user: SessionUser | null;
  hydrated: boolean; // true once an initial /me check has resolved (or there was no token)
  demo: boolean; // public demo mode (auto-login as the demo employee)
  setSession: (token: string, user: SessionUser) => void;
  setUser: (user: SessionUser | null) => void;
  setHydrated: (value: boolean) => void;
  setDemo: (value: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: getToken(),
  user: null,
  hydrated: false,
  demo: false,
  setSession: (token, user) => {
    setToken(token);
    set({ token, user, hydrated: true });
  },
  setUser: (user) => set({ user }),
  setHydrated: (value) => set({ hydrated: value }),
  setDemo: (value) => set({ demo: value }),
  logout: () => {
    clearToken();
    set({ token: null, user: null, hydrated: true }); // demo flag is preserved
  },
}));
